import React from 'react'
import styled from 'styled-components'
import './loading.css'

const InitialLoading = () => (
  <Content>
    <Wrapper>
      <div className="sk-circle-i">
        <div className="sk-circle1 sk-child"></div>
        <div className="sk-circle2 sk-child"></div>
        <div className="sk-circle3 sk-child"></div>
        <div className="sk-circle4 sk-child"></div>
        <div className="sk-circle5 sk-child"></div>
        <div className="sk-circle6 sk-child"></div>
        <div className="sk-circle7 sk-child"></div>
        <div className="sk-circle8 sk-child"></div>
        <div className="sk-circle9 sk-child"></div>
        <div className="sk-circle10 sk-child"></div>
        <div className="sk-circle11 sk-child"></div>
        <div className="sk-circle12 sk-child"></div>
      </div>
    </Wrapper>
  </Content>
)

const Content = styled.div `
  position: fixed;
  top: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #11837B;
`

const Wrapper = styled.div `
`

export default InitialLoading


// WEBPACK FOOTER //
// ./src/components/initialLoading/index.js